import { Event } from 'src/util/events/interfaces/Event';
import { PongConfiguration } from 'src/util/socket/types/PongConfiguration';

class TopicFactory {
	private pongConfiguration: PongConfiguration;

	public constructor(pongConfiguration: PongConfiguration) {
		this.pongConfiguration = pongConfiguration;
	}

	public createPublishTopic(event: Event): string {
		if (event.isGlobal) {
			return '/topic/user.' + this.pongConfiguration.ifsUserName;
		} else {
			if (event.isPersonal) {
				return '/topic/' + this.pongConfiguration.pongId + '.' + event.eventType;
			}
			return '/topic/' + event.eventType;
		}
	}

	public createSubscribeTopic(event: Event): string {
		if (event.isGlobal) {
			return '/topic/user.' + this.pongConfiguration.ifsUserName;
		} else {
			if (event.isPersonal) {
				return '/topic/' + this.pongConfiguration.pongId + '.#';
			}
			return '/topic/' + event.eventType;
		}
	}
}

export { TopicFactory };
